import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mapToCssModules, tagPropType } from './utils';

const propTypes = {
    tag: tagPropType,
    className: PropTypes.string,
    cssModule: PropTypes.object,
};

const defaultProps = {
    tag: 'div',
};

const ModalBody = ({ className, cssModule, tag: Tag, ...attributes }) => {
    const classes = mapToCssModules(classNames(
        className,
        'modal-body'
    ), cssModule);

    return (
        <Tag {...attributes} className={classes} />
    );
};

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;

export default ModalBody;
